import { FrequencyItem } from './frequencyitem'

export const WeeklyFrequencyItem = new FrequencyItem({
  id: '94d9159e-ebf5-4735-bcc9-ff70f4be5c26',
  name: 'weeklyFrequency',
  label: 'Weekly',
  type: 'WeeklyFrequency',
  key: '94d9159e-ebf5-4735-bcc9-ff70f4be5c26',
})
export const DailyFrequencyItem = new FrequencyItem({
  id: 'b4de1221-9b26-4454-be0b-71d8ce1e8147',
  name: 'dailyFrequency',
  label: 'Daily',
  type: 'DailyFrequency',
  key: 'b4de1221-9b26-4454-be0b-71d8ce1e8147',
})
export const HourlyFrequencyItem = new FrequencyItem({
  id: 'bf918671-0274-43cb-9bb0-26ecd4cd20a5',
  name: 'hourlyFrequency',
  label: 'Hourly',
  type: 'HourlyFrequency',
  key: 'bf918671-0274-43cb-9bb0-26ecd4cd20a5',
})
export const MinuteFrequencyItem = new FrequencyItem({
  id: '9d7d983f-3c7e-45e9-b50f-de4954734d37',
  name: 'minuteFrequency',
  label: 'Minute',
  type: 'MinuteFrequency',
  key: '9d7d983f-3c7e-45e9-b50f-de4954734d37',
})
